import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSubscriptionAccess } from "../subscriptionAccess.js";

export default function useSubscriptionAccess() {
  const subscription = useSelector(state => state.clientFunction?.companiesDB?.clientData?.subscription);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const refresh = () => setNow(Date.now());
    const timer = window.setInterval(refresh, 30000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);
  return getSubscriptionAccess(subscription, now);
}
